import { useEffect } from 'react';

export function useDisableMapInteractions(ref, mapRef) {
  useEffect(() => {
    const el = ref.current;
    const map = mapRef?.current;
    if (!el || !map) return;

    const disable = () => {
      map.dragging.disable();
      map.scrollWheelZoom.disable();
      map.doubleClickZoom.disable();
      map.boxZoom.disable();
      map.keyboard.disable();
      if (map.tap) map.tap.disable();
    };

    const enable = () => {
      map.dragging.enable();
      map.scrollWheelZoom.enable();
      map.doubleClickZoom.enable();
      map.boxZoom.enable();
      map.keyboard.enable();
      if (map.tap) map.tap.enable();
    };

    el.addEventListener('mouseenter', disable);
    el.addEventListener('mouseleave', enable);
    el.addEventListener('touchstart', disable, { passive: true });
    el.addEventListener('touchend', enable, { passive: true });

    return () => {
      el.removeEventListener('mouseenter', disable);
      el.removeEventListener('mouseleave', enable);
      el.removeEventListener('touchstart', disable);
      el.removeEventListener('touchend', enable);
      enable();
    };
  }, [ref, mapRef]);
}
